import { render } from "./GeneralDataMaterial.vue?vue&type=template&id=16d305ec"
import script from "./GeneralDataMaterial.vue?vue&type=script&lang=js"
export * from "./GeneralDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__